// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".amenities-page[data-v-1e6c3ffe]{padding:20px;display:flex;justify-content:center;align-items:baseline;flex-direction:column}.amenities-page .amenities-select[data-v-1e6c3ffe]{width:100%}", ""]);
// Exports
module.exports = exports;
